<div class="detail-page">
  <div class="otsake-container">
    <button class="sulje light-blue-text" mat-button (click)="peruuta()" type="button" [attr.aria-label]="'yleiset.peruuta' | translate | async">
      <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
    </button>
  </div>
  <form (ngSubmit)="save()" novalidate>
    <div style="max-width: 450px">
      <!-- <div> -->
      <!-- style="width: calc(96% - 120px); float: left;" -->
      <mat-form-field>
        <mat-label>{{ 'asiakas.nimi' | translate | async }}</mat-label>
        <input #nimiInput type="text" [formField]="lomake.nimi" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().nimi }}</mat-error>
      </mat-form-field>
      <!-- <mat-form-field class="valitsin" style="width: 120px; float: right;">
      <lemon-henkilo-yritys-valitsin formControlName="asiakastyyppi" required></lemon-henkilo-yritys-valitsin>
      <mat-error>{{fieldErrors.asiakastyyppi}}</mat-error>
    </mat-form-field> -->
      <!-- </div> -->
      <!-- class="ei_alaviivaa" -->
      <!-- <mat-form-field [floatLabel]="'always'" class="radio-buttonit">
  <mat-label>{{ 'asiakas.asiakastyyppi.asiakastyyppi' | translate | async }}</mat-label>
  <input type="text" formControlName="asiakastyyppi"  style="display: none;" matInput required data-lpignore="true" />
  <div style="transform: scale(.8); height: 28px; transform-origin: left 50%;">
    <mat-radio-group formControlName="asiakastyyppi" required>
      <mat-radio-button color="primary" value="h">{{'asiakas.asiakastyyppi.henkilo' | translate | async}}</mat-radio-button>
      <mat-radio-button color="primary" value="y">{{'asiakas.asiakastyyppi.yritys' | translate | async}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-error>{{fieldErrors.asiakastyyppi}}</mat-error>
</mat-form-field> -->
      <mat-form-field>
        <mat-label>{{ 'asiakas.ytunnus' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.ytunnus" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().ytunnus }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'asiakas.katuosoite' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.katuosoite" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().katuosoite }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'asiakas.postinro' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.postinro" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().postinro }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'asiakas.postitoimipaikka' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.postitoimipaikka" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().postitoimipaikka }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'asiakas.maa' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.maa" style="width: 100%">
          @for (maa of maat(); track maa) {
            <mat-option [value]="maa.koodi">
              {{ maa.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div style="margin-bottom: 0.5em; margin-top: 2em">
        <h3>{{ 'lasku.asiakas-dialog.laskun-toimitus' | translate | async }}</h3>
        <mat-radio-group [formField]="lomake.oletusLahetystapa" style="display: flex; gap: 16px; flex-wrap: wrap">
          <mat-radio-button color="primary" value="e">{{ 'lasku.asiakas-dialog.toimitustapa.verkkolasku' | translate | async }}</mat-radio-button>
          <mat-radio-button color="primary" value="s">{{ 'lasku.asiakas-dialog.toimitustapa.sahkoposti' | translate | async }}</mat-radio-button>
          <mat-radio-button color="primary" value="i">{{ 'lasku.asiakas-dialog.toimitustapa.itse' | translate | async }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div style="margin-bottom: 0.5em; margin-top: 2em">
        <h3>{{ 'asiakas.verkkolaskuotsikko' | translate | async }}</h3>
        <mat-form-field>
          <mat-label>{{ 'asiakas.verkkolaskuvalittaja' | translate | async }}</mat-label>
          <input type="text" [matAutocomplete]="operaattoriauto" [formField]="lomake.elaskuvalittaja" matInput data-lpignore="true" />
          <mat-error>{{ fieldErrors().elaskuvalittaja }}</mat-error>
        </mat-form-field>
        <mat-autocomplete #operaattoriauto="matAutocomplete" [displayWith]="valittajaDisplayFn">
          @for (operaattori of verkkolaskuoperaattorit | async; track operaattori) {
            <mat-option [value]="operaattori">{{ operaattori.tunnus }} {{ operaattori.nimi }}</mat-option>
          }
        </mat-autocomplete>

        <mat-form-field>
          <mat-label>{{ 'asiakas.verkkolaskuosoite' | translate | async }}</mat-label>
          <input type="text" [formField]="lomake.elaskuosoite" matInput data-lpignore="true" />
          <mat-error>{{ fieldErrors().elaskuosoite }}</mat-error>
        </mat-form-field>
      </div>

      <div style="margin-bottom: 0.5em; margin-top: 2em">
        <h3>{{ 'asiakas.vastaanottaja' | translate | async }}</h3>
        <mat-chip-grid #vastaanottajaChips style="margin-bottom: 0.5em">
          @for (vastaanottaja of asiakas.laskunVastaanottajat; track vastaanottaja) {
            <mat-chip-option [removable]="true" (removed)="poistaAsiakas(vastaanottaja)">
              {{ vastaanottaja }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-option>
          }
        </mat-chip-grid>
      </div>
      <mat-form-field>
        <mat-label>{{ 'lasku.sposti.lisaavastaanottaja' | translate | async }}</mat-label>
        <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" (blur)="lisaa()" [formField]="lomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaaAsiakas($event)" matInput matInput data-lpignore="true" />
        <!-- <mat-icon matSuffix (click)="lisaa()">add</mat-icon> -->
        <mat-error>{{ fieldErrors().lisaavastaanottaja }}</mat-error>
      </mat-form-field>

      <div style="display: flex; justify-content: space-between">
        <button class="secondarybutton" mat-button routerLink="/laskutus/asiakkaat" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
        @if (asiakas?.avain && asiakas?.avain !== 'uusi') {
          <button class="secondarybutton" mat-button (click)="poista()" type="button">{{ 'yleiset.poista' | translate | async }}</button>
        }
        <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
      </div>
    </div>
  </form>
</div>
